import { useKeycloak } from "@react-keycloak/web";
import NoPermission from "./NoPermission";

interface RoleBasedRouteProps {
  children: React.ReactNode;
  requiredRole: string;
}

const RoleBasedRoute = ({ children, requiredRole }: RoleBasedRouteProps) => {
  const { keycloak } = useKeycloak();

  const isLoggedIn = keycloak.authenticated;

  if (!isLoggedIn) {
    return null;
  }

  // Check if user has the required role
  const userRoles = Array.isArray(
    keycloak?.resourceAccess?.medianestclient?.roles,
  )
    ? keycloak.resourceAccess.medianestclient.roles
    : [];

  const hasRequiredRole = userRoles.includes(requiredRole);

  return hasRequiredRole ? children : <NoPermission />;
};

export default RoleBasedRoute;
